var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.3981 1.61994L6.63964 9.809C6.57373 9.87684 6.57373 9.94468 6.50782 10.0125L5.50977 12.949L8.62634 11.8538C8.69225 11.8538 8.75816 11.786 8.82407 11.7182L16.5166 3.59694C16.7144 3.32559 16.9121 2.9864 16.978 2.50184C17.0439 2.09481 16.978 1.68778 16.5166 1.33889C16.0553 0.990012 15.6504 0.931864 15.2549 1.06754C14.9254 1.20322 14.5958 1.40673 14.3887 1.61025L14.3981 1.61994Z",
    stroke: "#3069B2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.21984 1.30957H1V16.9996H16.5734V9.90566",
    stroke: "#3069B2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.f346de268fd001429f2224c6547092bf.svg";
export { ForwardRef as ReactComponent };